import { fillNeedsWhiteInsideLabel } from '../../../foundations/chart-colors'

/**
 * In-band percent captions for five-band and three-band rating fills (H8).
 *
 * White on `--chart-positive` (#2eb87c, hsl(154 60% 45%)) measured **2.55:1**
 * light / **2.03:1** dark — both below the 3:1 UI-text floor. Captions were
 * made mandatory as the relief for the 2.48:1 fill, so `text-white` made the
 * relief itself illegible.
 *
 * `--mint-foreground` (hsl(177 53% 8%), #0A2120) is the existing pairing for
 * text on mint/green fills and does not flip in `.dark`. On `--chart-positive`
 * it measures **6.65:1** light / **8.28:1** dark.
 *
 * Every other fill (red, orange, grey) goes through `measureInsideLabelContrast`
 * — white vs black at 4.5:1. No hue special case.
 */
export const BAND_CAPTION_TEXT_CLASS =
  'px-0.5 text-[11px] font-semibold tabular-nums text-[hsl(var(--mint-foreground))]'

const BAND_CAPTION_WARM_CLASS =
  'px-0.5 text-[11px] font-semibold tabular-nums text-white'

export function bandCaptionTextClass(fillColor?: string): string {
  if (fillColor && fillNeedsWhiteInsideLabel(fillColor)) {
    return BAND_CAPTION_WARM_CLASS
  }
  return BAND_CAPTION_TEXT_CLASS
}
